import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import SidebarContent from './ZSidebarContent';

function Sidebar(props) {
  const {
    classes,
    open,
    toggleDrawerOpen,
    leftSidebar,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeStatus = newStatus => {
    handleClose();
  };

  const toggleDrawerOpens = () => {
    return toggleDrawerOpen
  }
  return (
    <Fragment>
      <Drawer
        // variant={LabelCSS.variant.permanent}
        onClose={toggleDrawerOpens}
        className={open ? classes.drawer : ''}
        open={open}
        anchor={leftSidebar ? 'left' : 'right'}
      >
        <SidebarContent
          // roleID={props.roleID} subscriptionID={props.subscriptionID} offlineTime={props.offlineTime}
          drawerPaper={open}
          leftSidebar={leftSidebar}
          anchorEl={anchorEl}
          openMenuStatus={handleOpen}
          closeMenuStatus={handleClose}
          changeStatus={handleChangeStatus}
          // history={props.history}
          // screenshotEnable={props.screenshotEnable}
        />
      </Drawer>
    </Fragment>
  );
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawerOpen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  leftSidebar: PropTypes.bool,
};

Sidebar.defaultProps = {
  leftSidebar: true
};

export default withStyles(Sidebar);

